<template>
    <div class="add_approval_wrap">
        <div class="return_page_wrap">
           <span @click="handleClickReturn">
               <i class="el-icon-arrow-left"></i>返回
           </span>
            <span class="return_page_title" v-text="approvalName"></span>
        </div>
        <div class="add_approval_container">
            <div class="add_approval_container_top">
                <div v-loading="loading" class="add_approval_container_top_form">
                    <CustomFormPc
                            :approvalId="approvalId"
                            :field_list="formInfoList"
                            :form_detail="formData"
                            :pk_id="edit_approval_id ? edit_approval_id : again_approval_id ? again_approval_id : 0"
                            ref="approval_custom_form"
                            @submit-form="submitFormData"
                            @send-form-data="sendFormData"
                            v-if="dataLoaded"
                    />
                    <!--                            pk_id="pk_id"-->
                </div>

                <div class="add_approval_select_process" v-if="!edit_approval_id">
                    <div class="add_approval_select_process_title"><span>审批流程</span></div>
                    <approveProcessSelect ref="approveProcessSelectRef"
                                          :approval_node_list="approval_node_list"></approveProcessSelect>
                </div>
            </div>
            <div class="add_approval_container_bottom">
                <el-button size="small" @click="handleClickClose">取消</el-button>
                <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">确定
                </el-button>
            </div>
        </div>

    </div>
</template>
<script>
    import {getApprovalFormInfo,editApprovalFormInfo,approvalDetail,getFormFields, getApprovalNodes, getFiledKey, approvalAdd, PurchaseAdd,getAgainApprovalFormInfo,getAgainApprovalPeople} from "@/api/index.js"
    import CustomFormPc from "@/components/pComponents/CustomFormPc";
    import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
    import {removeTag} from "@/utils"
    export default {
        name: 'approveAdd',
        components: {
            CustomFormPc,
            approveProcessSelect
        },
        data() {
            return {
                approvalName: '',
                approvalId: 0,
                approvalType: null,
                btnDisabled: false,
                formInfoList: [],
                formData: null,
                loading: false,
                dataLoaded: false,
                approval_node_list: [],//审批流程
                again_approval_node_list:[],//重新发起时的审批流程中的自选人员
                condition_filed_key: [], //作为条件的字段
                isFormCheck: false,//表单校验
                field_auth_readonly:[],//权限只读
                field_auth_hide:[],//权限隐藏
                edit_approval_id:0,//修改审批id
                again_approval_id:0,//重新发起审批id
                node_id:0, //审批节点id
            }
        },

        mounted() {

        },
        created() {
            this.approvalId = this.$route.query.id ? Number(this.$route.query.id) : 0
            this.approvalName = this.$route.query.name
            this.approvalType = this.approval_type_mapping(this.$route.query.type)
            this.again_approval_id = this.$route.query.again_approval_id ? Number(this.$route.query.again_approval_id) : 0
            if(this.$route.query.edit_approval_id){
                this.edit_approval_id = Number(this.$route.query.edit_approval_id)
                this.getApprovalDetail(this.$route.query.edit_approval_id)
            }else{
                this.getFiledKey()
            }

        },
        methods: {
            // 审批详情
            getApprovalDetail(approval_id) {
                getApprovalFormInfo({approval_id}).then((res) => {
                    if (res.code === 200) {
                        this.formData = res.data || {};
                        approvalDetail({approval_id}).then((res) => {
                            if (res.code === 200) {
                                // 查找需要操作的流程节点
                                const node_item = res.data.node_list.find((item) => item.need_operation == 1);
                                this.field_auth_readonly = node_item.field_auth.filter(find =>   find.field_auth == 1 ).map((item)=> item.field_key) // 只读
                                this.field_auth_hide = node_item.field_auth.filter(find =>   find.field_auth == 3 ).map((item)=> item.field_key) // 隐藏
                                this._getFromFields()
                            }
                        });

                    }
                });
            },
            // 再次发起审批详情
            getApprovalDetailAgain() {
                getAgainApprovalFormInfo({approval_id:this.again_approval_id}).then((res) => {
                    if (res.code === 200) {
                        this.formData = res.data || {};
                        this.dataLoaded = true
                    }
                })
            },

            // 获取审批的字段
            _getFromFields() {
                this.loading = true
                getFormFields({
                    field_form: this.approvalType ? this.approvalType : 'approval_type_' + this.approvalId
                }).then(res => {
                    if (res.code === 200) {
                        this.formInfoList = res.data

                        // 没有权限的字段隐藏
                        if(this.field_auth_hide.length>0){
                            this.formInfoList.forEach((item)=>{
                                if(this.field_auth_hide.includes(item.field_key)){
                                    item.extend.initial_display = true
                                    item.extend.initial_display_delete = false
                                }
                            })
                            // this.formInfoList =  this.formInfoList.filter(item => !this.field_auth_hide.includes(item.field_key));
                        }
                        // 不可编辑的字段设置
                        if(this.field_auth_readonly.length>0){
                            this.formInfoList.forEach((item)=>{
                                if(this.field_auth_readonly.includes(item.field_key)){
                                    item.field_disabled = true
                                }
                            })
                        }
                        if(this.again_approval_id){
                            this.getApprovalDetailAgain()
                        }else{
                            this.dataLoaded = true
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            // 映射
            approval_type_mapping(type){
                let data = {
                    purchase:'purchases',
                }
                return data[type] ? data[type] : type
            },

            // 获取作为条件的字段
            getFiledKey() {
                getFiledKey({
                    approval_set_id: this.approvalId,
                }).then(res => {
                    if (res.code === 200) {
                        this.condition_filed_key = res.data.map(item => {
                            return item.field_key
                        })
                        // if(this.again_approval_id){
                        //     this.getAgainApprovalPeople()
                        // }else{
                        //     this.getApprovalNodes() //获取审批流
                        // }
                        this.getApprovalNodes() //获取审批流

                    } else {
                        this.$message.error(res.message)
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            // 获取审批流
            getApprovalNodes(only = false) {
                let form_value = JSON.parse(JSON.stringify(this.formData))
                this.approval_node_list = []
                let postData = {
                    approval_set_id: this.approvalId,
                }
                if (form_value) {
                    postData.form_value = form_value
                }
                getApprovalNodes(postData).then(res => {
                    if (res.code === 200) {
                        this.approval_node_list = res.data
                        this.field_auth_readonly = res.data[0].field_auth.filter(find =>   find.field_auth == 1 ).map((item)=> item.field_key) // 只读
                        this.field_auth_hide = res.data[0].field_auth.filter(find =>   find.field_auth == 3 ).map((item)=> item.field_key) // 隐藏
                        if(!this.again_approval_id){
                            this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                        }else{
                            if(this.again_approval_id && this.again_approval_node_list.length == 0 && only == false){
                                this.getAgainApprovalPeople()
                            }else{
                                this.set_again_approval_node_list()
                            }
                        }
                        if (only == false) {
                            this._getFromFields() //获取审批字段
                        }
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            set_again_approval_node_list(data){
                this.$nextTick(()=>{
                    this.approval_node_list.forEach((item,index)=>{
                        let set_node = this.again_approval_node_list.find(find => find.set_node_id == item.id)
                        if(set_node){
                            if(item.ccusers){
                                item.ccusers.forEach((child)=>{
                                    if(child.type == 'submitter_choice'){
                                        this.$set(child, 'relate_user', set_node.cc_info.map(map => {
                                            return {
                                                uid: map.id,
                                                avatar: map.avatar,
                                                name: map.name
                                            }
                                        }))
                                    }
                                })
                            }
                            if(item.handle.type == 'submitter_choice'){
                                this.$set(item.handle, 'relate_user', set_node.approval_info.map(map => {
                                    return {
                                        uid: map.id,
                                        avatar: map.avatar,
                                        name: map.name
                                    }
                                }))
                            }
                        }

                    })
                    this.$refs.approveProcessSelectRef.set_approval_node_list(this.approval_node_list)
                })
            },
            // 再次发起获取审节点
            getAgainApprovalPeople(){
                let node_ids = []
                this.approval_node_list.forEach((item)=>{
                    if(item.id && item.handle.type == 'submitter_choice'){
                        node_ids.push(item.id)
                    }
                })
                let postData = {
                    approval_id:this.again_approval_id,
                    node_ids:node_ids
                }
                getAgainApprovalPeople(postData).then(res => {
                    if (res.code === 200) {
                        let {data} = res
                        this.again_approval_node_list = data
                        this.set_again_approval_node_list()
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            handleClickReturn() {
                this.$router.go(-1)
            },
            // 取消
            handleClickClose() {
                this.$router.go(-1)
            },
            // 确认提交
            handleClickConfirm() {
                this.$refs.approval_custom_form.handleClickPublish();
            },
            submitFormData(customForm) {

                if (customForm) {
                    // 审批修改
                    if(this.edit_approval_id){
                        this.btnDisabled = true
                        editApprovalFormInfo({
                            approval_id:this.edit_approval_id,
                            form_data:customForm,
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '修改成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false
                                        removeTag(this.$route)
                                        this.$router.go(-1);
                                    }
                                })
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                        return  false
                    }

                    if (this.$refs.approveProcessSelectRef.handleClickPublish() == false) {  //审批节点校验没通过
                        return false
                    }
                    this.btnDisabled = true;
                    if (this.approvalType == 'purchases') { //采购申请
                        let flag = false
                        customForm.purchase_details.forEach((item, index) => {
                            if (!item.product_name || !item.num || item.price == '') {
                                flag = true
                            }
                        })
                        if (flag) {
                            this.$message.error('请把采购明细填写完整')
                            this.btnDisabled = false;
                            return false
                        }
                        // 预付款金额 ==  0或不填写时为全款支付
                        if(customForm && customForm.prepayment_price.value == '' || customForm.prepayment_price.value == 0){
                            this.$set(customForm.prepayment_price,'text',customForm.pay_total_price.text)
                            this.$set(customForm.prepayment_price,'value',customForm.pay_total_price.value)
                        }
                        if(customForm && customForm.pre_due_date && customForm.pre_due_date.value == ''){
                            this.$set(customForm.pre_due_date,'value',null)
                        }


                        customForm.node_list = this.approval_node_list
                        PurchaseAdd(customForm).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '提交成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false
                                        removeTag(this.$route)
                                        this.$router.go(-1);
                                    }
                                })
                            } else {
                                this.btnDisabled = false
                            }
                        }).catch(() => {
                            this.btnDisabled = false;
                        })
                    } else {
                        let data = {
                            approval_set_id: this.approvalId,
                            node_list: this.approval_node_list,
                            form_data: customForm,
                        }
                        approvalAdd(data).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '提交成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false
                                        removeTag(this.$route)
                                        this.$router.go(-1);
                                    }
                                })
                            } else {
                                this.btnDisabled = false
                            }

                        })
                    }

                }
            },
            // 表单编辑了
            sendFormData(data) {
                console.log(data);
                let editFieldData = []
                if (!this.formData) {
                    this.formData = JSON.parse(JSON.stringify(data))
                    this.getApprovalNodes(true)
                }
                this.condition_filed_key.forEach((item) => {
                    if (JSON.stringify(this.formData[item]) != JSON.stringify(data[item])) {
                        editFieldData.push(item)
                    }
                })
                this.formData = JSON.parse(JSON.stringify(data))
                if (editFieldData && editFieldData.length > 0) {
                    this.getApprovalNodes(true)
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "@/styles/approval.scss";
</style>